import React, { useMemo } from "react";
import { Box } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useFormContext } from "react-hook-form";
import classNames from "classnames";
import Question from "./Question";
import Result from "./Result";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  },
  questionContainer: {
    backgroundColor: "transparent",
    padding: theme.spacing(1, 3, 0, 3),
  },
  halfWidthContainer: {
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(0, 3),
    },
  },
}));

const Step = ({ step, result, onInputChange, onSubmit }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const { key, label, questions } = step;
  const isResultStep = key !== "START";
  const { watch } = useFormContext();
  const values = watch();

  const filteredQuestions = useMemo(() => {
    const matchesAnswer = (condition) => {
      const formValue = values[condition.key];

      return Array.isArray(condition.value)
        ? condition.value.includes(formValue)
        : formValue === condition.value;
    };

    return questions?.filter((question) => {
      if (!question.conditions) return true;
      return question.conditions.every(matchesAnswer);
    });
  }, [values, questions]);

  return (
    <>
      {!isResultStep && isDesktop && (
        <Typography variant="h3">
          Punkte, Bußgeld oder Fahrverbot berechnen
        </Typography>
      )}

      <Box className={classes.root}>
        <Box
          mb={2}
          flexGrow={1}
          className={classNames({
            [classes.halfWidthContainer]: isResultStep && isDesktop,
          })}
        >
          <Typography variant="h1">{label}</Typography>
          <Box className={classes.questionContainer}>
            {filteredQuestions?.map((question) => {
              return (
                <Question
                  key={question.key}
                  question={question}
                  onChange={onInputChange}
                  onSubmit={onSubmit}
                />
              );
            })}
          </Box>
        </Box>
        {isResultStep && <Result result={result} />}
      </Box>
    </>
  );
};

export default Step;
